/*
 * 一体化4K终端
 */
import React from 'react';
import cn from 'classnames';
import Scheme from 'components/product/scheme';
import Contact from 'components/contact';
import Wrapper from 'components/product/relevance/wrapper';
import MultipleBanner from 'components/product/banner/multiple';
import Medias from 'components/medias';
import style from './index.module.scss';
const IMG_PATH = 'https://sdk-source.xylink.com/website/assets/hardware/cloud/AE350_380/';
const scheme = [
  {
    title: '领导桌面视频会商',
    pcUrl: IMG_PATH + 'scheme-img3.jpg',
  },
  {
    title: '客服专家坐席',
    pcUrl: IMG_PATH + 'scheme-img2.jpg',
  },
  {
    title: '灵活场景视频协作',
    pcUrl: IMG_PATH + 'scheme-img1.jpg',
  },
  {
    title: '应急指挥调度舱',
    pcUrl: IMG_PATH + 'scheme-img0.jpg',
  },
];
const features = [
  {
    name: '声音',
  },
  {
    name: '视频',
  },
  {
    name: '控制',
  },
  {
    name: 'Wi_Fi',
  },
  {
    name: 'SIM卡',
  },
  {
    name: '电池',
  },
];

const Index = () => {
  return (
    <Wrapper title="一体化4K终端" menuIndex="2" current={0} customClass={style.ae350}>
      <MultipleBanner
        mUrl={`${IMG_PATH}m/bgM-image1.png`}
        className={(style.banner, style.firstBanner)}
        type={4}
        pcUrl={`${IMG_PATH}bg-image0.jpg`}
        title={'一体化4K\n全场景终端'}
        animate={'fadeIn'}
        delay={0.5}
        desc={'可移动便携式视频会议终端，远程办公头等舱\n支持各种网络会议室、移动桌面、户外等全场景应用'}
        mDesc={'可移动便携式视频会议终端，远程办公头等舱\n支持各种网络会议室、移动桌面、户外等全场\n景应用'}
      />
      <div className={style.outline}>
        <div className={style.title}>桌面臻品</div>
        <div className={style.outlineWrap}>
          {new Array(4).fill('').map((item: string, index: number) => {
            return <img className={style.outlineItem} key={index} src={`${IMG_PATH}desk-icon${index}.jpg`} alt="" />;
          })}
        </div>
      </div>
      <MultipleBanner
        mUrl={`${IMG_PATH}m/bgM-image3.jpg`}
        className={cn(style.banner)}
        type={4}
        pcUrl={`${IMG_PATH}bg-image3.jpg`}
        title={'灵动操控，极简体验'}
        animate={'fadeIn'}
        delay={0.5}
        desc={'高度集成的一体化触控终端，机身小巧灵便\n弹指间掌控更多功能，妙趣无限'}
      />
      <Medias
        title="集大成者，至简“无线”"
        desc="轻松部署，集音视频能力于一体，支持WiFi、移动蜂窝网络等接入方式"
        features={features}
        imgPre={IMG_PATH}
        bgImage={'bg-image4.jpg'}
        bgImageM={'m/bg-img0.jpg'}
      />
      <MultipleBanner
        mUrl={`${IMG_PATH}m/bgM-image2.jpg`}
        className={cn(style.banner, style.banner1)}
        type={4}
        pcUrl={`${IMG_PATH}bg-image2.jpg`}
        title={'性能拓展，应用无限'}
        animate={'fadeIn'}
        delay={0.5}
        desc={'可拓展4K云台摄像机，全向数字麦克风\n外接电视大屏扩展显示，带来优异会议体验'}
      />
      <MultipleBanner
        mUrl={`${IMG_PATH}m/bgM-image4.jpg`}
        className={cn(style.banner)}
        type={3}
        pcUrl={`${IMG_PATH}bg-image1.jpg`}
        title={'全网环境适应，稳定保障'}
        animate={'fadeIn'}
        delay={0.5}
        desc={'H.264、H.265柔性编解码算法\n超强网络适应性，有效保障会议稳定流畅'}
      />
      <Scheme animate="fadeIn" delay={0.5} type={3} data={scheme} title={'应用场景'} className={style.scene} />
      <Contact className={style.contact} btnType={'newBtn'} />
    </Wrapper>
  );
};

export default Index;
